module.exports = __webpack_public_path__ + "img/DU.d2bb9a91.png";